const About = () => {
  return (
    <div className="bg-[#b62e31] py-16" id="about">
      <div className="px-6 mx-auto max-w-4xl xl:max-w-6xl xl:px-0">
        <h2 className="text-center text-white font-bold text-4xl">
          Our STORY begins
        </h2>
        <div className="mx-auto text-center mt-5 md:w-3/4">
          <div className="space-y-5 text-white">
            <p>
              "Once upon a time, in a garden of technology, there grew a rose of
              education.
            </p>
            <p>
              In a kindergarten and kinder garden, where young seedlings are
              nurtured and encouraged to grow, in the way that is right for
              each."{" "}
            </p>
            <p>“Once upon a time… “</p>
            <p>“…and that Time is Now!”</p>
            <p>“For there grows in the Rose's garden, a Dragon's EGG!”</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
